import type {
  ActivityLogFilters,
  ActivityLogsResponse,
  ApiResponse
} from '../../types/ApiTypes';
import { apiManager } from '../api/ApiManager';

export class ActivityLogService {
  async getActivityLogs(params?: ActivityLogFilters): Promise<ApiResponse<ActivityLogsResponse>> {
    return apiManager.get<ActivityLogsResponse>('/api/v1/admin/activity-logs', params);
  }
}

export const activityLogService = new ActivityLogService();
